var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #313131;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-black",
    transform: "translate(-486 236)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    className: "cls-1",
    width: 200,
    height: 200,
    transform: "translate(486 -236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-message-circle",
    "data-name": "Icon feather-message-circle",
    className: "cls-2",
    d: "M121.4,16.5h5.345a94.655,94.655,0,0,1,89.746,89.327l.012,5.552A94.84,94.84,0,0,1,82.163,197.642L26.8,216.1A7.823,7.823,0,0,1,16.9,206.2l18.456-55.367A94.915,94.915,0,0,1,121.4,16.5Zm0,174.113A79.323,79.323,0,0,0,200.854,111.4v-5.141a78.857,78.857,0,0,0-74.544-74.125l-4.69.012H121.4A79.18,79.18,0,0,0,50.764,146.771a7.822,7.822,0,0,1,.439,6L36.691,196.308,80.228,181.8a7.822,7.822,0,0,1,6,.439A78.383,78.383,0,0,0,121.4,190.613Z",
    transform: "translate(469.5 -252.5)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBlack);
export default __webpack_public_path__ + "static/media/message-black.7e7ebfb446670107018b4fd6c46b2724.svg";
export { ForwardRef as ReactComponent };